import { useExhibitorForm } from "./hooks/useExhibitorForm";
import { useState, useEffect, useRef } from "react"; 
import MediaSection from "./sections/MediaSection";
import BasicInfoSection from "./sections/BasicInfoSection";
import ContactSection from "./sections/ContactSection";
import LocationSection from "./sections/LocationSection";
import StallSection from "./sections/StallSection";
import ScheduleSection from "./sections/ScheduleSection";
import StatusSection from "./sections/StatusSection";
import { useExhibitorCategory } from "components/exhibitorCategory/hooks/useExhibitorCategory";
import Alert from "components/common/Alert";


export default function ExhibitorForm({ initialData, onSubmit, onBack, alert, setAlert }) {
  
  const [selectedOrganizer, setSelectedOrganizer] = useState(
        localStorage.getItem("company_id") || ""
      );
      

  const userId = "69579c6190a653b640e65639";
  
  const {
    formData,
    errors,
    handleChange,
    handleFile,
    handleSubmit,
    existingLogo,
    existingBanner,
  } = useExhibitorForm(initialData, selectedOrganizer, userId, alert, setAlert);

  

  
      
  const { data, loadCategories } = useExhibitorCategory();
  
  const alertRef = useRef(null);

  useEffect(() => {
        if (selectedOrganizer) { 
          loadCategories(selectedOrganizer);
        }
      }, [selectedOrganizer]);
  
      useEffect(() => {
      const handleOrganizerChange = (e) => {
        setSelectedOrganizer(e.detail);
      };
  
      window.addEventListener("companyChanged", handleOrganizerChange);
      return () =>
        window.removeEventListener("companyChanged", handleOrganizerChange);
      }, []);

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [alert]);

  

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-8 bg-white p-6 rounded-xl">
       {alert && (
              <div
                ref={alertRef}
                className="px-6 pt-3 scroll-mt-[100px]"
              >
                <Alert
                  type="error"
                  message={alert}
                  onClose={() => setAlert("")}
                />
              </div>
            )}
      
    <input type="hidden" name="company_id" value={selectedOrganizer} />
    <input type="hidden" name="created_by" value={userId} />
    <input type="hidden" name="updated_by" value={userId} />

      <MediaSection
        data={formData}
        errors={errors}
        onFileChange={handleFile}
        existingLogo={existingLogo}  
        existingBanner={existingBanner} 
      />
      <BasicInfoSection
        data={formData}
        errors={errors}
        onChange={handleChange}
        exhibitors={data}
      />
      <ContactSection
        data={formData}
        errors={errors}
        onChange={handleChange}
        isEdit={!!initialData}
      />
      <LocationSection
        data={formData}
        errors={errors}
        onChange={handleChange}
      />
      {/* <StallSection
        data={formData}
        errors={errors}
        onChange={handleChange}
      />
      <ScheduleSection
        data={formData}
        onChange={handleChange}
      /> */}
      <StatusSection
        data={formData}
        onChange={handleChange}
      />
      <div className="flex justify-between">
        <button
          type="button"
          onClick={onBack}
          className="rounded bg-red-500 px-6 py-3 text-white"
        >
          Back
        </button>
        <button
          type="submit"
          className="rounded bg-brand-500 px-6 py-3 text-white"
        >
          {initialData ? "Update Exhibitor" : "Create Exhibitor"}
        </button>
      </div>
    </form>
  );
}